/* eslint-disable no-console */
import debounce from 'lodash.debounce'
import { useEffect } from 'react'

import Molten from '@leverege/molten'
import { GlobalState, UI } from '@leverege/ui-redux'

function SubscriptionHiddenDataViewer( { parentItem, ...rest } ) {
  const systemId = Molten.getConfig( 'api/systemId' )

  const getSubscriptionInfo = debounce( async () => {
    console.log( parentItem )
    const networkId = parentItem?.data?.networkId
    if ( !networkId ) {
      return
    }
    const esn = parentItem?.data?.networkAliases?.[networkId]?.esn
    if ( !esn ) {
      return
    }

    const data = await GlobalState.dispatch( ( dispatch, getState, { api } ) => {
      try {
        const response = api.system( systemId ).srv( 'subscriptions' ).get( esn )
        return response
      } catch ( error ) {
        console.error( error )
      }
      return undefined
    } )

    GlobalState.dispatch( UI.set( 'subscriptionInfo', data ) )
  } )

  useEffect( () => getSubscriptionInfo(), [] )
  
  return null
}

export default {
  type : 'SubscriptionHiddenDataViewer',
  name : 'Subscripion Info',
  matches : [ { objectType : 'boat' } ],
  icon : 'fa-solid fa-grid-2',
  location : 'hidden',
  handles : () => true,
  component : SubscriptionHiddenDataViewer,
}
